module.exports = __webpack_public_path__ + "img/preview.7a937528.webp";